import React from "react"
import { IMsgErrorInput } from "./interface"
import { Message } from "./style"

const MsgErrorInput = (props: IMsgErrorInput) => {

    return (
        <Message style={props.style}>
            { props.children }
        </Message>
    )
}

export default MsgErrorInput